import { render } from "./NcrmExternalApiWorkspace.vue?vue&type=template&id=9d437f48&scoped=true"
import script from "./NcrmExternalApiWorkspace.vue?vue&type=script&lang=js"
export * from "./NcrmExternalApiWorkspace.vue?vue&type=script&lang=js"

import "./NcrmExternalApiWorkspace.vue?vue&type=style&index=0&id=9d437f48&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d437f48"]])

export default __exports__